import React from "react";
import { Box, Typography, Button, Container, Grid, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SecurityIcon from "@mui/icons-material/Security";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PlanCard from "./PlanCard";
import HeroSection from "./HeroSection";
import AboutTheApp from "./AboutTheApp";
import WhatsAppButton from "../../../components/WhatsAppButton";

const Home = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <RocketLaunchIcon sx={{ fontSize: 48 }} />,
      title: "سهولة الاستخدام",
      description: "واجهة بسيطة وسهلة تساعدك على البدء فوراً",
    },
    {
      icon: <TrendingUpIcon sx={{ fontSize: 48 }} />,
      title: "تحسين الأداء",
      description: "زيادة الإنتاجية وتحسين إدارة مطعمك",
    },
    {
      icon: <SecurityIcon sx={{ fontSize: 48 }} />,
      title: "أمان عالي",
      description: "حماية كاملة لبياناتك ومعلومات عملائك",
    },
    {
      icon: <SupportAgentIcon sx={{ fontSize: 48 }} />,
      title: "دعم فني مستمر",
      description: "فريق دعم متاح على مدار الساعة",
    },
  ];

  return (
    <Box>
      {/* Hero Section */}
      <HeroSection />

      {/* Features Section */}
      <Box
        sx={{
          py: 10,
          background: "white",
          position: "relative",
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Typography
              variant="h3"
              gutterBottom
              fontWeight={800}
              sx={{
                background: "linear-gradient(135deg, #f36f21 0%, #e65100 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                mb: 2,
              }}
            >
              لماذا تختار ريستو كاش؟
            </Typography>
            <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: 600, mx: "auto" }}>
              نوفر لك كل ما تحتاجه لإدارة مطعمك باحترافية
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    height: "100%",
                    textAlign: "center",
                    borderRadius: 4,
                    border: "1px solid #e0e0e0",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 12px 40px rgba(243, 111, 33, 0.15)",
                      borderColor: "#f36f21",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, rgba(243, 111, 33, 0.1) 0%, rgba(230, 81, 0, 0.1) 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto",
                      mb: 3,
                      color: "#f36f21",
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography variant="h6" fontWeight={700} gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary", lineHeight: 1.8 }}>
                    {feature.description}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Plans Section */}
      <PlanCard />

      {/* About Section */}
      <AboutTheApp />

      {/* CTA Section */}
      <Box
        sx={{
          py: 10,
          background: "linear-gradient(135deg, #f36f21 0%, #e65100 100%)",
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "radial-gradient(circle at 30% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)",
            pointerEvents: "none",
          },
        }}
      >
        <Container maxWidth="md" sx={{ position: "relative", zIndex: 1, textAlign: "center" }}>
          <Typography
            variant="h3"
            gutterBottom
            fontWeight={800}
            sx={{
              color: "white",
              mb: 3,
              textShadow: "0 2px 10px rgba(0,0,0,0.2)",
            }}
          >
            هل أنت مستعد للبدء؟
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: "rgba(255,255,255,0.9)",
              mb: 5,
              lineHeight: 1.8,
            }}
          >
            انضم إلى مئات المطاعم التي تستخدم ريستو كاش لإدارة أعمالها بكفاءة
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 3,
              justifyContent: "center",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate("/signup")}
              sx={{
                px: 5,
                py: 2,
                fontSize: "1.1rem",
                fontWeight: 700,
                borderRadius: 3,
                background: "white",
                color: "#f36f21",
                textTransform: "none",
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                "&:hover": {
                  background: "rgba(255,255,255,0.95)",
                  transform: "translateY(-3px)",
                  boxShadow: "0 12px 32px rgba(0,0,0,0.3)",
                },
              }}
            >
              ابدأ مجاناً الآن 🚀
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate("/contact-us")}
              sx={{
                px: 5,
                py: 2,
                fontSize: "1.1rem",
                fontWeight: 700,
                borderRadius: 3,
                borderWidth: 2,
                borderColor: "white",
                color: "white",
                textTransform: "none",
                "&:hover": {
                  borderWidth: 2,
                  borderColor: "white",
                  background: "rgba(255,255,255,0.15)",
                  transform: "translateY(-3px)",
                },
              }}
            >
              تواصل معنا
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Stats Section */}
      <Box
        sx={{
          py: 8,
          background: "white",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} sx={{ textAlign: "center" }}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="h2"
                fontWeight={800}
                sx={{
                  background: "linear-gradient(135deg, #f36f21 0%, #e65100 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                500+
              </Typography>
              <Typography variant="h6" sx={{ color: "text.secondary", mt: 1 }}>
                مطعم يثق بنا
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="h2"
                fontWeight={800}
                sx={{
                  background: "linear-gradient(135deg, #f36f21 0%, #e65100 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                99%
              </Typography>
              <Typography variant="h6" sx={{ color: "text.secondary", mt: 1 }}>
                نسبة رضا العملاء
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="h2"
                fontWeight={800}
                sx={{
                  background: "linear-gradient(135deg, #f36f21 0%, #e65100 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                24/7
              </Typography>
              <Typography variant="h6" sx={{ color: "text.secondary", mt: 1 }}>
                دعم فني متواصل
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="h2"
                fontWeight={800}
                sx={{
                  background: "linear-gradient(135deg, #f36f21 0%, #e65100 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                100K+
              </Typography>
              <Typography variant="h6" sx={{ color: "text.secondary", mt: 1 }}>
                طلب تمت معالجته
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* WhatsApp Floating Button */}
      <WhatsAppButton />
    </Box>
  );
};

export default Home;
